import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import SprzedazSearchbox from "./components/SprzedazSearchbox";
import TrasyService from "../../konfiguracja/trasyConfig/trasy/TrasyService";
import RaportyService from "../RaportyService";
import GodzinowyChart from "./components/GodzinowyChart";
import DatowyChart from "./components/DatowyChart";
import TrasowyChart from "./components/TrasowyChart";
import initialData from "../../../utilities/initialData/initialData";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import moment from 'moment'

export default class SprzedazJednorazowychContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy: [],
            daneTrasowyZnizki: [],
            daneTrasowyGeneral: [],
            daneGodzinowyZnizki: [],
            daneGodzinowyGeneral: [],
            daneDatowyZnizki: [],
            daneDatowyGeneral: [],
            params: null,
            colorArray: []
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()
        this.setState({colorArray: initialData.returnColorArray()})

        // inicjacja szukania
        this.onClickSzukaj({
            "dataDo": DateAndTimeFormat.formatYYYYMMDD(moment()),
            "dataOd": DateAndTimeFormat.formatYYYYMMDD(moment()),
            "godz1p": null,
            "idTr": null,
            "nazTr": null,
            "statPoz": null,
            "statusNazwa": null
        })
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }


    onClickSzukaj(data) {
        RaportyService.pobierzRaportBiletow(data).then(function (response) {
            this.setState({params: data})

            if (Boolean(data.idTr)) {
                // wykresy godiznowy i datowy dla danej trasy
                this.setState({
                    daneGodzinowyZnizki: response.data[0][0],
                    daneGodzinowyGeneral: response.data[0][1],
                    daneDatowyZnizki: response.data[1][0],
                    daneDatowyGeneral: response.data[1][1],
                })

            }
            else {
                // wykres trasowy

                this.setState({
                    daneTrasowyZnizki: response.data[0],
                    daneTrasowyGeneral: response.data[1],
                })

            }

        }.bind(this))
    }

    renderDataZMiesiacem(data) {
        let rok = data.substr(0, 4)
        let msc = data.substr(5, 2)
        let dzien = data.substr(8, 2)
        let miesiac = 'styczeń'
        if (msc == 2) miesiac = 'luty'
        else if (msc == 3) miesiac = 'marzec'
        else if (msc == 4) miesiac = 'kwiecień'
        else if (msc == 5) miesiac = 'maj'
        else if (msc == 6) miesiac = 'czerwiec'
        else if (msc == 7) miesiac = 'lipiec'
        else if (msc == 8) miesiac = 'sierpień'
        else if (msc == 9) miesiac = 'wrzesień'
        else if (msc == 10) miesiac = 'październik'
        else if (msc == 11) miesiac = 'listopad'
        else if (msc == 12) miesiac = 'grudzień'
        return (dzien + ' ' + miesiac + ' ' + rok)
    }

    renderNaglowek(params) {

        let naglowek = 'Sprzedaż dla wszystkich tras'
        if (Boolean(params.idTr)) {
            naglowek = 'Sprzedaż dla trasy ' + params.nazTr
        }

        if (params.dataOd == params.dataDo) {
            naglowek = naglowek + ' w dniu ' + this.renderDataZMiesiacem(params.dataOd)
        }
        else naglowek = naglowek + ' w okresie od ' + this.renderDataZMiesiacem(params.dataOd) + ' do ' + this.renderDataZMiesiacem(params.dataDo)

        if (Boolean(params.godz1p)) {
            naglowek = naglowek + ' o godzinie ' + params.godz1p.replace('.', ':')
        }

        if (Boolean(params.statPoz)) {
            naglowek = naglowek + ' ze statusem ' + params.statusNazwa
        }

        return naglowek
    }

    zwrocRozniceDniPomiedzyDatami(dataod, datado) {
        if (dataod === datado) {
            return 0
        }
        else {
            let time1 = new Date(dataod).getTime()
            let time2 = new Date(datado).getTime()

            return (time2 - time1) / (1000 * 60 * 60 * 24)
        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'} style={{marginBottom: '5px'}}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {addressUrl: '/raporty/sprzedaz-jednorazowych', text: 'Sprzedaż biletów jednorazowych'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <SprzedazSearchbox trasy={this.state.trasy} handleClickSzukaj={this.onClickSzukaj}/>
                        </Col>
                    </Row>
                    {
                        Boolean(this.state.params) ?
                            Boolean(this.state.params.idTr) ?
                                <Row>
                                    <Col xs={12}>
                                        <h2 style={{textAlign: 'center'}}>{this.renderNaglowek(this.state.params)}</h2>
                                    </Col>
                                    <Col xs={12}
                                         lg={12}>
                                        <GodzinowyChart
                                            colorArray={this.state.colorArray}
                                            daneGodzinowyZnizki={this.state.daneGodzinowyZnizki}
                                            daneGodzinowyGeneral={this.state.daneGodzinowyGeneral}
                                            czyNaCalaDlugosc={true}
                                        />
                                    </Col>
                                     <Col xs={12}
                                         lg={12}>
                                        <DatowyChart
                                            colorArray={this.state.colorArray}
                                            daneDatowyZnizki={this.state.daneDatowyZnizki}
                                            daneDatowyGeneral={this.state.daneDatowyGeneral}
                                            czyNaCalaDlugosc={true}
                                        />
                                    </Col>
                                </Row>
                                :
                                <Row>
                                    <Col xs={12}>
                                        <h2 style={{textAlign: 'center'}}>{this.renderNaglowek(this.state.params)}</h2>
                                    </Col>
                                    <Col xs={12} lg={12}>
                                        <TrasowyChart
                                            daneTrasowyZnizki={this.state.daneTrasowyZnizki}
                                            daneTrasowyGeneral={this.state.daneTrasowyGeneral}
                                            colorArray={this.state.colorArray}
                                        />

                                    </Col>
                                </Row>
                            :
                            ''
                    }
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazJednorazowych/SprzedazJednorazowychContainer.js